import React from 'react';
import TabPanel from '@mui/lab/TabPanel';
import RadarChartCompetency from '@core/components/radarchart/RadarChartCompetency';

import OnboardingSteps from 'components/pages/career-competency/onboardingsteps/OnboardingSteps';

import classes from './CompetencyTabPanel.module.scss';

const InfoItems = ({ items }) => {
    if (!items || items.length === 0) return null;
    return (
        <div className={classes['info-items']}>
            {items.map((item, i) => (
                <div key={i} className={classes['info-item']}>
                    <h6 className={classes['info-item-title']}>{item.title}</h6>
                    <p className={classes['info-item-description']}>{item.description}</p>
                </div>
            ))}
        </div>
    );
};

const CompetencyTabPanel = ({
    value,
    chartData,
    emptyChartData,
    marketData,
    title,
    description,
    emptyTitle,
    emptyDescription,
    emptyActions,
    infoItems
}) => {
    return (
        <TabPanel className='p-0' value={value}>
            {chartData ? (
                <div className={classes['user-progress-wrapper']}>
                    <div className={classes['chart-wrapper']}>
                        <RadarChartCompetency chartData={chartData} marketData={marketData} />
                    </div>
                    <h5>{title}</h5>
                    <p>{description}</p>
                    <InfoItems items={infoItems} />
                </div>
            ) : (
                <div className={classes['no-data']}>
                    <div className={classes['chart-wrapper']}>
                        <RadarChartCompetency chartData={emptyChartData} marketData={marketData} />
                    </div>
                    <OnboardingSteps />
                    <h5>{emptyTitle}</h5>
                    <p>{emptyDescription}</p>
                    {emptyActions && (
                        <div className='d-flex gap-3 align-items-center justify-content-center flex-wrap'>
                            {emptyActions}
                        </div>
                    )}
                    <InfoItems items={infoItems} />
                </div>
            )}
        </TabPanel>
    );
};

export default CompetencyTabPanel;
